import { useLayoutEffect, useRef } from 'react';

const useRestoreFocus = (isOpen: boolean) => {
  const openerRef = useRef<HTMLElement | null>(null);

  useLayoutEffect(() => {
    if (isOpen) {
      openerRef.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    }
  }, [isOpen]);

  const restoreFocus = () => {
    const { activeElement } = document;

    if (!activeElement || activeElement === document.body) {
      openerRef.current?.focus();
    }
  };

  return restoreFocus;
};

export default useRestoreFocus;
